var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2071 2.29289C17.5976 2.68342 17.5976 3.31658 17.2071 3.70711L9.41421 11.5L17.2071 19.2929C17.5976 19.6834 17.5976 20.3166 17.2071 20.7071C16.8166 21.0976 16.1834 21.0976 15.7929 20.7071L7.29289 12.2071C6.90237 11.8166 6.90237 11.1834 7.29289 10.7929L15.7929 2.29289C16.1834 1.90237 16.8166 1.90237 17.2071 2.29289Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.1b5084e3c24671a9f007155f5ef34389.svg";
export { ForwardRef as ReactComponent };